<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>{{ "PUBLIC_CHECKOUT.TITLE" | translate }}</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/landing" [text]="'COMMON.BACK' | translate"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <div class="flex flex-col items-center">
    <div class="w-full max-w-[650px] px-4">
      <!-- Header Section -->
      <div
        class="from-primary mx-0 mt-4 flex min-h-[120px] flex-col rounded-3xl bg-gradient-to-br to-purple-700 px-6 py-6 dark:from-blue-700 dark:to-purple-800"
      >
        <ion-text class="text-xl font-bold text-white">
          {{ "PUBLIC_CHECKOUT.HEADER" | translate }}
        </ion-text>
        <ion-text class="mt-2 text-white/70">
          {{ "PUBLIC_CHECKOUT.DESCRIPTION" | translate }}
        </ion-text>
      </div>

      <!-- Order Loading State -->
      @switch (checkoutStore.getPublicOrderState().type) {
        @case ("loading") {
          <div class="mt-8 flex justify-center">
            <ion-spinner name="crescent" color="primary"></ion-spinner>
          </div>
        }
        @case ("error") {
          <mtjr-error [failure]="checkoutStore.getPublicOrderFailure()" />
        }
        @case ("success") {
          @if (checkoutStore.order(); as order) {
            <!-- Order Summary Card -->
            <ion-card class="mt-6 border-none">
              <div class="p-4">
                <div class="mb-3 flex items-center">
                  <div class="flex flex-1 flex-col">
                    <ion-text class="text-medium text-sm">{{ "ORDERS.ORDER_ID" | translate }}</ion-text>
                    <ion-text color="dark" class="text-lg font-bold">{{ order.orderNo }}</ion-text>
                  </div>
                </div>
                <div class="bg-light h-[1px] w-full"></div>

                <!-- Order Products -->
                @for (subOrder of order.subOrders; track subOrder.id) {
                  <div class="mt-4">
                    <ion-text class="text-medium text-sm">{{ subOrder.orderProducts[0].vendorName }}</ion-text>
                    @for (item of subOrder.orderProducts; track item.id) {
                      <div class="mt-3 flex items-start gap-3">
                        <img
                          [src]="
                            item.productImage ??
                            item.variationImage ??
                            'https://nbg1.your-objectstorage.com/mtjr-prod/product-placeholder.webp'
                          "
                          class="h-16 w-16 rounded-lg border border-solid border-medium/30"
                          [class.object-contain]="item.productType === 'digital'"
                          [class.object-cover]="item.productType !== 'digital'"
                          [alt]="item.productName"
                        />
                        <div class="flex flex-1 flex-col">
                          <ion-text class="font-medium">{{ item.productName }}</ion-text>
                          <div class="mt-1 flex items-center gap-2">
                            <ion-text color="primary" class="font-bold">
                              {{ item.finalPrice | vxCurrency }}
                            </ion-text>
                            <ion-text color="medium" class="text-sm">× {{ item.quantity }}</ion-text>
                          </div>
                        </div>
                        <ion-text color="dark" class="font-bold">
                          {{ item.finalPrice | vxCurrency }}
                        </ion-text>
                      </div>
                    }
                  </div>
                }

                <!-- Totals -->
                <div class="bg-light mt-4 h-[1px] w-full"></div>
                <div class="mt-4 space-y-2">
                  <div class="flex items-center justify-between">
                    <ion-text color="medium">{{ "ORDERS.SUB_TOTAL" | translate }}</ion-text>
                    <ion-text color="dark">{{ order.subTotal | vxCurrency }}</ion-text>
                  </div>
                  <div class="flex items-center justify-between">
                    <ion-text color="dark" class="font-bold">{{ "ORDERS.TOTAL" | translate }}</ion-text>
                    <ion-text color="primary" class="text-xl font-bold">{{ order.total | vxCurrency }}</ion-text>
                  </div>
                </div>
              </div>
            </ion-card>

            <!-- Payment Button -->
            <ion-card class="mt-4 border-none">
              <div class="p-4">
                @if (checkoutStore.createPaymentIntentFailure()) {
                  <div class="mb-4">
                    <mtjr-error-bar [failure]="checkoutStore.createPaymentIntentFailure()" />
                  </div>
                }

                <ion-button expand="block" color="primary" class="h-12" (click)="paymentMethodSelector.start()">
                  {{ "PUBLIC_CHECKOUT.CONTINUE_TO_PAYMENT" | translate }}
                </ion-button>
              </div>
            </ion-card>

            <!-- Info Section -->
            <ion-card class="mt-4 border-none">
              <div class="p-4">
                <div class="flex items-center gap-3">
                  <ion-icon name="shield-checkmark-outline" class="text-primary text-2xl"></ion-icon>
                  <div>
                    <ion-text class="font-bold">{{ "PUBLIC_CHECKOUT.SECURE_PAYMENT" | translate }}</ion-text>
                    <p class="text-medium mt-1 text-sm">{{ "PUBLIC_CHECKOUT.SECURE_PAYMENT_DESC" | translate }}</p>
                  </div>
                </div>
              </div>
            </ion-card>
          }
        }
      }
    </div>
  </div>
</ion-content>
<mtjr-payment-method-selector
  #paymentMethodSelector
  [paymentIntentType]="'guestCheckout'"
  [modalTitle]="'PUBLIC_CHECKOUT.SELECT_PAYMENT_METHOD' | translate"
  [submitButtonLabel]="'PUBLIC_CHECKOUT.PAY_NOW' | translate"
  [amount]="checkoutStore.order()?.subTotal"
  [orderId]="orderId()"
/>
